export function openInNewTab(openInNewTabUrl: string, targetWindow?: Window) {
    (targetWindow || window).open(openInNewTabUrl, '_blank');
}
